module.exports = __webpack_public_path__ + "6008c80bc1856e916bae57609ad4355c.svg";